"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoSizedColumnVirtualizedMultiGrid = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVirtualized = require("react-virtualized");

var _virtualizedConstants = require("./constants/virtualizedConstants");

var _virtualizedUtilities = require("./utilities/virtualizedUtilities");

var _icons = require("../constants/icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var AutoSizedColumnVirtualizedMultiGrid =
/*#__PURE__*/
function (_Component) {
  _inherits(AutoSizedColumnVirtualizedMultiGrid, _Component);

  var _super = _createSuper(AutoSizedColumnVirtualizedMultiGrid);

  function AutoSizedColumnVirtualizedMultiGrid(props) {
    var _this;

    _classCallCheck(this, AutoSizedColumnVirtualizedMultiGrid);

    _this = _super.call(this, props);
    _this.columnKeys = (0, _virtualizedUtilities.getColumnKeysInOrder)(_this.props.resultConfiguration);
    _this.rows = (0, _virtualizedUtilities.createHeaderRow)(_this.props.rows, _this.columnKeys);
    _this.getColumnWidth = _this.getColumnWidth.bind(_assertThisInitialized(_this));
    _this.getHeaderSortArrow = _this.getHeaderSortArrow.bind(_assertThisInitialized(_this));
    _this.cellRenderer = _this.cellRenderer.bind(_assertThisInitialized(_this));
    _this.renderMultiGrid = _this.renderMultiGrid.bind(_assertThisInitialized(_this));
    return _this;
  } // eslint-disable-next-line complexity, max-statements


  _createClass(AutoSizedColumnVirtualizedMultiGrid, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.rows !== this.props.rows || nextProps.resultConfiguration !== this.props.resultConfiguration || nextProps.configuration !== this.props.configuration) {
        this.columnKeys = (0, _virtualizedUtilities.getColumnKeysInOrder)(nextProps.resultConfiguration);
        this.rows = (0, _virtualizedUtilities.createHeaderRow)(nextProps.rows, this.columnKeys); // cache.clearAll();

        this.grid.recomputeGridSize();

        _virtualizedConstants.cache.clearAll();

        this.grid.forceUpdate();
        return true;
      }

      if (nextProps.isDragging) {
        this.grid.recomputeGridSize();
        this.grid.forceUpdate();
        return true;
      }

      return false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _virtualizedConstants.cache.clearAll();
    }
  }, {
    key: "getRowClass",
    value: function getRowClass(columnIndex, rowIndex, content) {
      var alternatingRowClass = (0, _virtualizedUtilities.getAlternatingRowClass)(columnIndex, rowIndex, this.props.configuration);
      var firstRowClass = (0, _virtualizedUtilities.getFirstRowClass)(rowIndex);
      var lastRowClass = (0, _virtualizedUtilities.getLastRowClass)(rowIndex, this.props.rows.length);
      var fixedColumnClass = (0, _virtualizedUtilities.getFixedColumnClass)(columnIndex, this.props.configuration);
      var customRowClass = this.props.getCustomRowClass ? this.props.getCustomRowClass(columnIndex, content) : '';
      return "".concat(alternatingRowClass, " ").concat(firstRowClass, " ").concat(lastRowClass, " ").concat(fixedColumnClass, " ").concat(customRowClass);
    } // eslint-disable-next-line complexity

  }, {
    key: "getColumnWidth",
    value: function getColumnWidth(_ref) {
      var _this2 = this;

      var index = _ref.index;

      if (this.props.getColumnWidth) {
        return this.props.getColumnWidth(this.columnKeys[index]);
      }

      var columnConfiguration = this.props.resultConfiguration.find(function (configuration) {
        return configuration.fieldName === _this2.columnKeys[index];
      });

      if (columnConfiguration && parseInt(columnConfiguration.columnWidth, 10) !== 0) {
        return columnConfiguration.columnWidth;
      }

      return this.props.configuration.defaultColumnWidth;
    }
  }, {
    key: "getHeaderSortArrow",
    value: function getHeaderSortArrow(columnKey) {
      var columnDirection = this.props.columnNamesAndOrderBy[columnKey];

      if (!columnDirection) {
        return (
          /*#__PURE__*/
          _react["default"].createElement("i", {
            className: "".concat(_icons.icons.sort, " multi-grid__sort-arrow--not-sorted")
          })
        );
      }

      if (columnDirection === 'asc') {
        return (
          /*#__PURE__*/
          _react["default"].createElement("span", {
            className: "".concat(_icons.icons.asc, " multi-grid__sort-arrow")
          })
        );
      }

      return (
        /*#__PURE__*/
        _react["default"].createElement("span", {
          className: "".concat(_icons.icons.desc, " multi-grid__sort-arrow")
        })
      );
    } // eslint-disable-next-line complexity, max-statements,

  }, {
    key: "cellRenderer",
    value: function cellRenderer(renderParams) {
      var columnIndex = renderParams.columnIndex,
          key = renderParams.key,
          parent = renderParams.parent,
          rowIndex = renderParams.rowIndex,
          style = renderParams.style;
      var content = this.rows[rowIndex];
      var contentKey = this.columnKeys[columnIndex];

      if (rowIndex === 0) {
        var _updatedStyle = _objectSpread(_objectSpread({}, style), {}, {
          width: '100%'
        });
        /* eslint-disable jsx-a11y/click-events-have-key-events */


        if (this.props.renderDraggableIcon) {
          return (
            /*#__PURE__*/
            _react["default"].createElement(_reactVirtualized.CellMeasurer, {
              cache: _virtualizedConstants.cache,
              columnIndex: columnIndex,
              key: key,
              parent: parent,
              rowIndex: rowIndex
            },
            /*#__PURE__*/
            _react["default"].createElement("div", {
              style: style,
              key: key,
              className: "multi-grid__header",
              onClick: this.props.onHeaderClick(contentKey)
            },
            /*#__PURE__*/
            _react["default"].createElement("div", {
              className: "multi-grid__header-label-container"
            },
            /*#__PURE__*/
            _react["default"].createElement("label", {
              className: "multi-grid__header-label"
            }, this.props.labels.fieldLabels[contentKey]), this.getHeaderSortArrow(contentKey)), this.props.renderDraggableIcon(contentKey)))
          );
        }

        return (
          /*#__PURE__*/
          _react["default"].createElement(_reactVirtualized.CellMeasurer, {
            cache: _virtualizedConstants.cache,
            columnIndex: columnIndex,
            key: key,
            parent: parent,
            rowIndex: rowIndex
          },
          /*#__PURE__*/
          _react["default"].createElement("div", {
            style: _updatedStyle,
            key: key,
            onClick: this.props.onHeaderClick(contentKey),
            className: "multi-grid__header"
          }, this.props.labels.fieldLabels[contentKey], this.getHeaderSortArrow(contentKey)))
        );
        /* eslint-enable jsx-a11y/click-events-have-key-events */
      }

      var updatedStyle = _objectSpread(_objectSpread({}, style), {}, {
        width: this.getColumnWidth({
          index: columnIndex
        })
      });

      return (
        /*#__PURE__*/
        _react["default"].createElement(_reactVirtualized.CellMeasurer, {
          cache: _virtualizedConstants.cache,
          columnIndex: columnIndex,
          key: key,
          parent: parent,
          rowIndex: rowIndex
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: updatedStyle,
          key: key,
          className: "multi-grid__body ".concat(this.getRowClass(columnIndex, rowIndex, content))
        }, this.props.customContentRenderer ? this.props.customContentRenderer(contentKey, content) : content[contentKey]))
      );
    }
  }, {
    key: "renderMultiGrid",
    value: function renderMultiGrid(height, width) {
      var _this3 = this;

      return (
        /*#__PURE__*/
        _react["default"].createElement(_reactVirtualized.MultiGrid, _extends({}, this.props, {
          className: "multi-grid",
          cellRenderer: this.cellRenderer,
          columnWidth: this.getColumnWidth,
          columnCount: this.columnKeys.length,
          enableFixedColumnScroll: true,
          enableFixedRowScroll: true,
          fixedColumnCount: this.props.configuration.fixedColumnCount,
          fixedRowCount: this.props.configuration.fixedRowCount,
          height: height,
          hideBottomLeftGridScrollbar: true,
          hideTopRightGridScrollbar: true,
          overscanColumnCount: this.props.configuration.overscanColumnCount,
          overscanRowCount: this.props.configuration.overscanRowCount,
          rowHeight: _virtualizedConstants.cache.rowHeight,
          rowCount: this.rows.length,
          width: width // eslint-disable-next-line no-return-assign
          ,
          ref: function ref(grid) {
            return _this3.grid = grid;
          }
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return (
        /*#__PURE__*/
        _react["default"].createElement(_reactVirtualized.AutoSizer, null, function (_ref2) {
          var height = _ref2.height,
              width = _ref2.width;
          return _this4.renderMultiGrid(height, width);
        })
      );
    }
  }]);

  return AutoSizedColumnVirtualizedMultiGrid;
}(_react.Component);

exports.AutoSizedColumnVirtualizedMultiGrid = AutoSizedColumnVirtualizedMultiGrid;
AutoSizedColumnVirtualizedMultiGrid.propTypes = {
  labels: _propTypes["default"].instanceOf(Object).isRequired,
  columnNamesAndOrderBy: _propTypes["default"].instanceOf(Object),
  configuration: _propTypes["default"].instanceOf(Object),
  customContentRenderer: _propTypes["default"].func,
  getCustomRowClass: _propTypes["default"].func,
  getColumnWidth: _propTypes["default"].func,
  isDragging: _propTypes["default"].bool,
  onHeaderClick: _propTypes["default"].func,
  renderDraggableIcon: _propTypes["default"].func,
  resultConfiguration: _propTypes["default"].instanceOf(Array),
  rows: _propTypes["default"].instanceOf(Array).isRequired
};
AutoSizedColumnVirtualizedMultiGrid.defaultProps = {
  columnNamesAndOrderBy: [],
  configuration: {
    defaultColumnWidth: 150,
    fixedColumnCount: 0,
    fixedRowCount: 1,
    rowHeight: 30,
    scrollToColumn: 0,
    scrollToRow: 0,
    overscanColumnCount: 10,
    overscanRowCount: 10
  },
  customContentRenderer: null,
  getCustomRowClass: function getCustomRowClass() {
    return '';
  },
  getColumnWidth: null,
  isDragging: false,
  onHeaderClick: function onHeaderClick() {
    return null;
  },
  renderDraggableIcon: null,
  resultConfiguration: []
};